import SideBar from './sideBar.view';

export default SideBar;
